import { LANDING_ROUTES } from '@/modules/landing/api';

/**
 * Convite do agendamento no WhatsApp.
 *
 * O link leva o id do agendamento: quem abrir encontra tudo que ja foi
 * lancado e continua de onde o salao parou, em vez de comecar do zero.
 */
export function bookingInviteUrl(slug: string, appointmentId: string | null): string {
  const base = `${window.location.origin}${LANDING_ROUTES.publicPage(slug)}`;

  return appointmentId ? `${base}?agendamento=${appointmentId}` : base;
}

export function whatsappInvite(params: {
  slug: string;
  appointmentId: string | null;
  phone: string | null;
  customerName: string;
  companyName?: string;
}): string {
  const url = bookingInviteUrl(params.slug, params.appointmentId);
  const saudacao = `Ola, ${params.customerName.split(' ')[0] ?? ''}!`.replace(' !', '!');
  const texto = params.appointmentId
    ? `${saudacao} Seu agendamento${params.companyName ? ` no ${params.companyName}` : ''} esta aqui: ${url}`
    : `${saudacao} Agende seu horario${params.companyName ? ` no ${params.companyName}` : ''}: ${url}`;

  const digits = (params.phone ?? '').replace(/\D/g, '');
  const destino = digits.length >= 10 ? `${digits.length <= 11 ? `55${digits}` : digits}` : '';

  return `https://wa.me/${destino}?text=${encodeURIComponent(texto)}`;
}
